import { Alert } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../../common/Localization';

interface Props {
    missingIds: number[];
}

export function MissingValueWarning(props: Props) {
    const visible: boolean = props.missingIds.length > 0;
    const rowIdStr: string = props.missingIds.join(', ');
    const content = props.missingIds.length > 1 ? constants.MISSING_DATA_MESSAGE.WARNING_MESSAGE_MULTI_ROW :
        constants.MISSING_DATA_MESSAGE.WARNING_MESSAGE_SINGLE_ROW;
    return (
        <Alert type='warning' header={constants.MISSING_DATA_MESSAGE.WARNING_HEADER} visible={visible}>
            <ul>
                <li>{props.missingIds.length} {content} {rowIdStr} </li>
                <li>{constants.MISSING_DATA_MESSAGE.WARNING_MESSAGE_PART_TWO}</li>
            </ul>
        </Alert>
    );
}
